import { useState } from "react";
import { accountService } from "../../services";
import { IPasswordComplexityResult } from "../../customTypings/auth/PasswordComplexityResult";

export const usePasswordValidation = (email: string) => {
    const [passwordComplexity, setPasswordComplexity] = useState<IPasswordComplexityResult>({
        isSuccess: false,
        score: 0,
        messages: [],
    });

    const validatePassword = (value: string) => {
        if (value === "") {
            setPasswordComplexity({ isSuccess: false, score: 0, messages: [] });
        } else {
            accountService
                .passwordComplexityCheck(email, value)
                .then(
                    (result: IPasswordComplexityResult) => {
                        setPasswordComplexity(result);
                    },
                    (error) => {
                        setPasswordComplexity({
                            isSuccess: false,
                            score: 0,
                            messages: [error],
                        });
                    }
                );
        }
    };

    return {
        passwordComplexity,
        validatePassword
    };
};
